<div class="modal-body">
    <div class="category-header">
        <label>New Bad Word</label>
    </div>

    <div class="roomname">
        <label>Bad Word</label>
        <input type="text" [(ngModel)]="badword" class="form-control" maxlength="90" />
    </div>
    <!-- <p *ngIf="error" class="text-danger">{{ error }}</p> -->
    <div class="form-group">
        <button *ngIf="action === 'add'" [disabled]="badword === ''" type="button" class="btn btn-primary move-buttons" (click)="onSave()">Create</button>
    </div>
    <!-- <div class="form-group">
        <button *ngIf="action === 'update'" [disabled]="roomname === ''" type="button" class="btn btn-primary move-buttons" (click)="updateRoom()">Update</button>
    </div> -->

    <div class="form-group">
        <button type="button" class="btn btn-secondary move-buttons-grey" (click)="onCancel()">Cancel</button>
    </div>
</div>
<app-snackbar></app-snackbar>
